import { useEffect } from "react";

import {
  PORTAL_EVENT_TYPES,
  recordPortalEventSafely,
} from "../service/portalEventsClient";

let didRecordFirstContentfulPaint = false;
let didRecordLanded = false;
let didRecordPageLoaded = false;

const recordLanded = () => {
  if (didRecordLanded) return;
  didRecordLanded = true;
  recordPortalEventSafely({
    eventType: PORTAL_EVENT_TYPES.landed,
  });
};

const recordFirstContentfulPaint = () => {
  if (didRecordFirstContentfulPaint) return;
  didRecordFirstContentfulPaint = true;
  recordPortalEventSafely({
    eventType: PORTAL_EVENT_TYPES.firstContentfulPaint,
  });
};

const recordPageLoaded = () => {
  if (didRecordPageLoaded) return;
  didRecordPageLoaded = true;
  recordPortalEventSafely({
    eventType: PORTAL_EVENT_TYPES.pageLoaded,
  });
};

const getFirstContentfulPaintEntry = () => {
  if (typeof window === "undefined" || !window.performance?.getEntriesByName) {
    return null;
  }
  return window.performance.getEntriesByName("first-contentful-paint")[0] || null;
};

const observeFirstContentfulPaint = () => {
  if (getFirstContentfulPaintEntry()) {
    recordFirstContentfulPaint();
    return undefined;
  }

  if (typeof window === "undefined" || !window.PerformanceObserver) {
    return undefined;
  }

  const observer = new window.PerformanceObserver((list) => {
    const hasFirstContentfulPaint = list
      .getEntries()
      .some((entry) => entry.name === "first-contentful-paint");
    if (hasFirstContentfulPaint) {
      recordFirstContentfulPaint();
      observer.disconnect();
    }
  });

  try {
    observer.observe({ type: "paint", buffered: true });
  } catch (_error) {
    observer.disconnect();
  }

  return () => observer.disconnect();
};

const usePortalPageLifecycleEvents = () => {
  useEffect(() => {
    recordLanded();
    const cleanupFirstContentfulPaint = observeFirstContentfulPaint();

    return () => {
      cleanupFirstContentfulPaint?.();
    };
  }, []);
};

export { recordPageLoaded as recordPortalPageLoaded };
export default usePortalPageLifecycleEvents;
